import { Fragment, useEffect, useState } from "react";
import {
    Card,
    Col,
    Container,
    Input,
    Label,
    Row
} from "reactstrap";
import { API } from "../../api/API";
import { getData } from "../../CommonElements/Functions/PostGetFun";
import { ensureDexieReady, getFilteredPositionIds } from "../../db/DexieServises";
import CardHeaderSpan from "../../Utils/CommonComponents/CardHeaderSpan";
import { ReportDARTitle, ReportListTitle, ReportTitle } from "../../Utils/Constants";
import MonthDropdown from "../CommonCompo/MonthDropdown";
import TreeModel from "../Dashboards/Attendance/AttendanceTable/TreeModel";
import CommonTable from "../Tables/ReactstrapTables/BasicTables/Common/CommonTable";
import DatePicker from 'react-datepicker'
import { useLocation, useParams } from "react-router-dom";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import FeatherIconCom from "../../Utils/CommonComponents/CommonIcons/FeatherIconCom";
import { Image } from "../../AbstractElements";
import { dynamicImage } from "../../Utils";
import { useSelector } from "react-redux";
import { RootState } from "../../redux-toolkit/store";
interface DARReportProps {
    positionId: string;
    startDate: string;
}

export default function DARReport({ positionId, startDate }: DARReportProps) {
    //    const { positionId } = useParams(); // from route
    //     const location = useLocation();
    const selectedMonths = startDate; // from state

    // console.log("positionId:", positionId);
    // console.log("startDate:", startDate);
    const [searchText, setSearchText] = useState('');
    const [selectedIds, setSelectedIds] = useState<(string | number)[]>([]);
    const [effortData, setEffortData] = useState<any[]>([]);
    const [displayedData, setDisplayedData] = useState<any[]>(effortData);
    const serverUrl = localStorage.getItem('serverUrl');
    const APP_TOKEN = localStorage.getItem('appToken');
    const [selectedMonth, setSelectedMonth] = useState<string>('');
    // const [startDate, setStartDate] = useState<Date | null>(new Date());
    const [loading, setLoading] = useState(true);
    const unitId = useSelector((state: RootState) => state.orgUnit.id);

    const handleChange = (date: Date | null) => {
        // setStartDate(date);
    };
    useEffect(() => {
        if (selectedMonths) {
            handleSubmitAPI();
        }
    }, [selectedMonths, selectedIds,unitId]);
    const handleSubmitAPI = async () => {
        if (!serverUrl || !APP_TOKEN) {
            console.error('❌ Missing server URL or app token');
            return;
        }
        await ensureDexieReady();

        const ids = await getFilteredPositionIds('Position', unitId);
        // console.log(ids, 'Filtered Position IDs');
        const positionIds = selectedIds.length > 0 ? selectedIds : ids;
        // const month = startDate?.toISOString().split('T')[0] || '';
        // console.log("📦 API Call Payload:", {
        //     position_id: positionId,
        //     date: selectedMonths
        // });

        const url = `${serverUrl}${API.getDarReport}`;
        const { status, data } = await getData(url, true, {
            position_id: positionId,
            date: selectedMonths,
        });

        if (status === 200 && Array.isArray(data?.data)) {

            console.log("📦 Raw API Data:getDarReport", data?.data); // <-- add this
            setEffortData(data?.data);
            setLoading(false); // 👈 Stop loader

        } else {
            setEffortData([]); // fallback
        }
        setLoading(false); // 👈 Stop loader
    };

    useEffect(() => {
        const lower = searchText.toLowerCase();

        const filtered = effortData.filter((item) => {
            // ✅ Only filter by search text (not by selectedIds)
            return item?.FirstName?.toLowerCase().includes(lower);
        });
        setDisplayedData(filtered);
        // console.log("📊 Filtered Data:", filtered);
    }, [searchText, effortData]); // ✅ remove selectedIds from dependency
    const keys = displayedData.length > 0 ? Object.keys(displayedData[0]) : [];

    const handleExportToExcel = () => {
        const exportData = displayedData.map(item => ({
            "Agenda Type": item.agendaType,
            "Name": item.fullName,
            "Managers Name": item.managerName,
            "Outlet Name": item.outletName,
            "Position Name": item.positionName,
            "Agenda Name": item.agendaName,
            "Start Town": item.startTown,
            "Date": item.date,
            "Status": item.status,
            "Planned": item.planned,
            "Sgpi Out": item.sgpiOut,
            "Pob Total": item.pobTotal,
            "Ed Duration": item.edDuration,
            "Outlettype Name": item.outletTypeName,
            "Beat Name": item.beatName,
            "Tags": item.tags,
            "Joint Working": item.jointWorking,
            "Campaign Name": item.campaignName,
        }));

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Agenda Report");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(blob, `Daily_Activity_Report_${new Date().toISOString().split("T")[0]}.xlsx`);
    };


    const captionTableHeader = [
        { id: 1, head: "Agenda Type" },
        // { id: 2, head: "Employee Code" },
        { id: 3, head: "Name" },
        { id: 4, head: "Managers Name" },
        { id: 5, head: "Outlet Name" },
        // { id: 5, head: "Outlet Code" },
        { id: 6, head: "Agenda Name" },
        { id: 7, head: "Position Name" },
        { id: 8, head: "Start Town" },
        { id: 9, head: "Date" },
        { id: 10, head: "Status" },
        { id: 11, head: "Planned" },
        // { id: 12, head: "Unit Name" },
        { id: 13, head: "Sgpi Out" },
        { id: 14, head: "Pob Total" },
        { id: 15, head: "Ed Duration" },
        { id: 16, head: "Outlettype Name" },
        { id: 17, head: "Beat Name" },
        { id: 18, head: "Tags" },
        { id: 19, head: "Joint Working" },
        { id: 20, head: "Campaign Name" },


    ]
    return (
        <div className='page-body '>
            <Card>
                <Fragment>
                    <Container fluid>

                        {/* <button className="btn btn-sm btn-primary d-flex align-items-center" onClick={handleExportToExcel}>
                            <FeatherIconCom iconName="Upload" size={14} className="text-light" />
                            <span className="px-2" style={{ fontSize: 14 }}>Export</span>
                        </button> */}
                        <Row>
                            <Col sm={12}>
                                <div className="table-responsive">
                                    {loading ? (
                                        <div className="text-center py-3">
                                            {/* <span className="spinner-border text-primary" role="status" aria-hidden="true" /> */}
                                            <div>
                                                <Image
                                                    className="b-r-10 img-80"
                                                    src={dynamicImage('dashboard/loader.gif')}
                                                    alt="Loading..."
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <CommonTable caption="" headData={captionTableHeader}>
                                            {displayedData.length === 0 ? (
                                                <tr>
                                                    <td colSpan={captionTableHeader.length} className="text-center">
                                                        No data found.
                                                    </td>
                                                </tr>
                                            ) : (
                                                displayedData.map((row, rowIndex) => (
                                                    <tr key={rowIndex}>
                                                        <td >{row.Agendacontroltype || "-"} </td>
                                                        {/* <td >{row.EmployeeCode} </td> */}
                                                        <td >{row.FirstName || "-"} </td>
                                                        <td >{row.ManagersName || "-"} </td>
                                                        <td >{row.OutletName || "-"} </td>
                                                        {/* <td >{row.OutletCode} </td> */}
                                                        <td >{row.Agendname || "-"} </td>
                                                        <td >{row.PositionName || "-"} </td>
                                                        <td >{row.Stownname || "-"} </td>
                                                        <td >{row.DcrDate || "-"} </td>
                                                        <td >{row.DcrStatus || "-"} </td>
                                                        <td >{row.Planned || "-"} </td>
                                                        {/* <td >{row.UnitName} </td> */}
                                                        <td >{row.SgpiOut || "-"} </td>
                                                        <td >{row.PobTotal || "-"} </td>
                                                        <td >{row.EdDuration || "-"} </td>
                                                        <td >{row.OutlettypeName || "-"} </td>
                                                        <td >{row.BeatName || "-"} </td>
                                                        <td >{row.Tags || "-"} </td>
                                                        {/* <td >{row.Isjw} </td> */}
                                                        <td>{row.Isjw ? "true" : "false"}</td>

                                                        <td >{row.BrandCampaignName || "-"} </td>

                                                    </tr>
                                                ))
                                            )}
                                        </CommonTable>)}
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Fragment>
            </Card>
        </div>
    );
}
